<template>
  <div class="relative flex min-h-screen xl:static">
    <TheLeftSidebarNavigation
      v-model="isSidebarExpanded"
      class="hidden xl:static xl:block"
    />

    <div
      id="right-side-content"
      scroll-region
      class="relative flex h-screen flex-auto flex-col overflow-y-auto"
    >
      <div
        class="relative flex items-center gap-x-3 border-b bg-surface-0 p-4 border-surface xl:static xl:hidden"
      >
        <Button
          severity="secondary"
          variant="outlined"
          rounded
          icon="ri-menu-fill"
          v-styleclass="{
            selector: 'aside',
            enterFromClass: 'hidden',
            enterActiveClass: 'animate-fadeinleft',
            leaveToClass: 'hidden',
            leaveActiveClass: 'animate-fadeoutleft',
            hideOnOutsideClick: true,
          }"
        >
          <RiMenuFill />
        </Button>

        <MusthadFullLogo class="w-36" />
      </div>

      <main class="flex flex-auto flex-col space-y-4 bg-surface-0 p-4">
        <slot />
      </main>

      <div id="sticky-footer" class="sticky bottom-0 z-50" />
    </div>
  </div>

  <CustomToast />
  <CustomDeleteConfirmDialog />
  <InertiaDevTools v-if="isDevEnvironment" />
</template>

<script setup lang="ts">
import RiMenuFill from '~icons/ri/menu-fill'
import MusthadFullLogo from '@/assets/images/logo-full.svg'
import { useCurrentUser } from '@/composables/useCurrentUser'
import { onMounted, ref, watch } from 'vue'
import CustomToast from '@/components/CustomToast.vue'
import CustomDeleteConfirmDialog from '@/components/CustomDeleteConfirmDialog.vue'
import InertiaDevTools from '@/components/InertiaDevTools.vue'
import * as Sentry from '@sentry/vue'
import TheLeftSidebarNavigation from '@/components/TheLeftSidebarNavigation.vue'
import { usePage } from '@inertiajs/vue3'

const { user } = useCurrentUser()

const isSidebarExpanded = ref(true)

const LOCAL_STORAGE_SIDEBAR_EXPANDED_KEY = 'sidebar-expanded'
watch(isSidebarExpanded, (value) => {
  localStorage.setItem(LOCAL_STORAGE_SIDEBAR_EXPANDED_KEY, value.toString())
})
onMounted(() => {
  const sidebarExpanded = localStorage.getItem(
    LOCAL_STORAGE_SIDEBAR_EXPANDED_KEY,
  )
  if (sidebarExpanded) {
    isSidebarExpanded.value = sidebarExpanded === 'true'
  }
})

const isDevEnvironment = import.meta.env.DEV

onMounted(() => {
  if (user.value.id) {
    Sentry.setUser({
      id: user.value.id,
    })
  }
})

const page = usePage()
watch(
  () => page.url,
  () => {
    document.querySelector('aside')?.classList.add('hidden')
  },
)
</script>

<style>
#right-side-content:has(#sticky-footer > *) main {
  padding-bottom: 6rem;
}
</style>
